import { createFileRoute } from "@tanstack/react-router";

import Opportunities from "@/features/opportunities/Opportunities";
import SideNavLayout from "@/layouts/SideNavLayout";
import { OpportunitiesMenu } from "@/layouts/SubSideNavMenus";

export const Route = createFileRoute("/_auth/opportunities/")({
  component: () => (
    <SideNavLayout menu={<OpportunitiesMenu />}>
      <Opportunities />
    </SideNavLayout>
  ),
});
